import { generateTypes } from '../utils/HttpReducerHelper';

export const emailInvite = generateTypes('FUNDING_REPORT', 'EMAIL_INVITE');
export const fundingReport = generateTypes('FUNDING_REPORT', 'FUNDING_REPORT');
export const inviteLink = generateTypes('FUNDING_REPORT', 'INVITE_LINK');

export * from './convertToFundingSearch/types';
export * from './delete/types';
export * from './list/types';
export * from './matches/types';
export * from './resendInvite/types';
